import React, { useEffect, useState } from "react";
import { errorNotify } from "../../../services/toast.notification";
import { getMiscellaneousFunctions} from '../../../api/api';
import { useAppDispatch, useAppSelector } from '../../../redux/store/storehooks';
import Spinner from "../../../components/_common/Spinner";
import { UpdateMiscellaneousFunctions } from "../../../redux/reducers/MiscellaneousFunctionsSlice";
import Table, { ColumnsType } from "antd/lib/table";
import '../style.css';
import Search from './ProcessListSearch'

export interface InputProps {
  url: any
}

const ProcessList = ({url}:InputProps) => {

    const columns: ColumnsType<any> = [
        {title: 'ردیف',dataIndex: 'id',key: 'id'},
        {title: 'فرآیند ',dataIndex: 'ProcessName',key: 'ProcessName'},      
    ];

  const [isLoading,setIsLoading] = useState(true);
  const [data, setData] = useState([]);

  const _getProcessList = (url:string,func:number,fromdate:string,todate:string) => {
    getMiscellaneousFunctions(url,func,fromdate,todate)
    .then((result:any) => {
      let jsonResult = JSON.parse(result.data.json);
      setData(jsonResult.processlist);
      setIsLoading(false);
    })
    .catch((error:any) => {
      console.log(error);
      errorNotify(error.response.data.errorMessage,undefined,5000)
    })   
}

  useEffect(() => {
    _getProcessList(url,0,'','');
  }, [])

  return(
    <div className="tab-content-padding">
     { 
        isLoading === false  && (
        <>
            <div className="inner-tabs_content">
            <Search data={data} columns={columns}/>

        </div>
        </> 
        )
    }
    {
      isLoading === true  && (
      <Spinner />
    )
    }
    </div>  
      
    )
}
export default ProcessList;
